import { Box, Button, Chip, Dialog, Divider, FormControl, FormHelperText, IconButton, MenuItem, Select, TextField, Typography } from "@mui/material";
import { empty, extractDataFromArray, findExperienceDataByType, generatePhrase, getActivityType, roundNumber, toastMessage, validateJSON } from "../../utils/common";
import * as Icon from '@mui/icons-material';
import { useEffect, useState } from "react";
import BookingService from "../../services/bookings";
import GreyLabel from "../formElement/GreyLabel";
import config from "../../config";
import { CommonContext } from "../../store/context/commonContext";
import PackageCardMobile from "../PackageCardMobile";
import { Link } from "react-router-dom";
import { capitalizeFirstLetter } from "../../utils/common";
import { ACCESS, EXPERIENCE } from "../CommonConstants/commonKeys";
import CreateChip from "../CreateChip";
import MediaCard from "../previewPageComponents/mediaCard";
import errorAndHelperText from "../CommonConstants/errorAndHelperText.json"

// package card used in booking details page only
export function PackageCard({ bookingData, clickable = false }) {

	const { isMobile } = CommonContext();
	const propertyName = `at ${extractDataFromArray(bookingData, ['listing', 'title'], '')}`
	const listingSeq = extractDataFromArray(bookingData, ['listing', 'seq'], '')
	const listingSlug = extractDataFromArray(bookingData, ['listing', 'slug'], '')
	let address = `${roundNumber(extractDataFromArray(bookingData, ['listing', 'area'], ''))} Acres, ${getActivityType(extractDataFromArray(bookingData, ['package', 'activity_type'], ''))} `
	const address2 = ` near ${extractDataFromArray(bookingData, ['listing', 'nearest_town'], '')}`
	const packageType = extractDataFromArray(bookingData, ['package_type'], '')

	let mediaType, photosData, packageTitle, generalData, locationData, pricingData;
	let durationObj = {}
	let media_obj


	if (packageType === 'experience') {
		photosData = findExperienceDataByType(bookingData.package, 'photos')
		media_obj = extractDataFromArray(photosData, ['photo_list', '0'], {})
		generalData = findExperienceDataByType(bookingData.package, 'general_info')
		locationData = findExperienceDataByType(bookingData.package, 'location')
		pricingData = findExperienceDataByType(bookingData.package, 'pricing')
		mediaType = extractDataFromArray(photosData, ['photo_list', 0, 'type'], '');
		packageTitle = extractDataFromArray(generalData, ['title'], '')
		address = ` Nearest Town, ${extractDataFromArray(locationData, ['city'], '')}`
		durationObj = extractDataFromArray(pricingData, ['package_duration'], {})
	} else if (packageType === 'access') {
		media_obj = extractDataFromArray(bookingData, ['package', 'media_url'], {})
		mediaType = extractDataFromArray(bookingData, ['package', 'media_url', 'type'], '')
		packageTitle = extractDataFromArray(bookingData, ['package', 'title'], '')
	} else {
		mediaType = extractDataFromArray(bookingData, ['package', 'media_url', 'type'], '')
	}

	const iconPathRetrieveFunc = () => {
		// console.log(bookingData);
		if (extractDataFromArray(bookingData, ['package', 'experience_type_key'], '') === 'RE') {
			return '../assets/images/event_exp_icon.svg'
		} else if (extractDataFromArray(bookingData, ['package', 'experience_type_key'], '') === 'OA') {
			return '../assets/images/outdoor_activity_exp_icon.svg'
		} else if (extractDataFromArray(bookingData, ['package', 'experience_type_key'], '') === 'GT') {
			return '../assets/images/tour_guide_exp_icon.svg'
		} else if (extractDataFromArray(bookingData, ['package', 'experience_type_key'], '') === 'IP' || extractDataFromArray(bookingData, ['package', 'experience_type'], '') === 'In-Person Training') {
			return '../assets/images/in-person.svg'
		}
	}

	const iconPath = iconPathRetrieveFunc()

	return (
		<Box sx={{
			p: 3, mb: 3, display: 'flex', gap: 2, border: '1px solid var(--grey500)', position: 'relative', borderRadius: (theme) => `${theme.card.borderRadius} `, cursor: 'pointer',
			":hover": {
				borderColor: "var(--black)"
			}
		}} onClick={
			(event) => {
				const isPropertyName = event.target.classList.contains('propertyName')
				if (clickable) {
					if (isPropertyName) {
						//    console.log("clicked name")
					} else {

						// console.log("card clicked")
						let locationToOpen = isMobile ? "_self" : "_blank"
						// console.log("/package/" + extractDataFromArray(bookingData, ['package', 'slug'], '') + "-" + extractDataFromArray(bookingData, ['package', 'seq'], ''))
						if (packageType === 'access') {
							window.open("/package/" + extractDataFromArray(bookingData, ['package', 'slug'], '') + "-" + extractDataFromArray(bookingData, ['package', 'seq'], ''), locationToOpen)
						} else if (packageType === 'experience') {
							window.open("/experience/" + extractDataFromArray(generalData, ['slug'], '') + "-" + extractDataFromArray(bookingData, ['package', 'seq'], ''), locationToOpen)
						}
					}
				}
			}}>
			<Box className='ChipContainer' sx={{ position: 'absolute', top: 32, left: 32, zIndex: 2 }}>
				{/* <Chip label={capitalizeFirstLetter(packageType)} variant="contained" size="small" sx={{ border: '1px solid #1B1B1B', borderColor: '#1B1B1B', color: '#1B1B1B', backgroundColor: '#ffffff' }} /> */}
				<CreateChip chipType={capitalizeFirstLetter(packageType)} size="small" sx={{ border: '1px solid #1B1B1B', borderColor: '#1B1B1B', color: '#1B1B1B', backgroundColor: '#ffffff' }} />
			</Box>
			{media_obj && Object.keys(media_obj).length > 0 && (
				<MediaCard
					imageObj={media_obj}
					width={'160px'}
					height={'100%'}
					borderRadius={'8px'}
				/>
			)}
			<Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: 'calc(100% - 180px)' }}>
				<Box>
					<Typography noWrap >{extractDataFromArray(bookingData, ['listing', 'title'], '')}</Typography>
					<Typography noWrap variant="h6" sx={{ fontWeight: 700 }}>{packageTitle}</Typography>
					{
						packageType === 'access' ?
							<Box>
								<Typography component={'span'} variant='body2' sx={{ color: 'var(--grey900)' }}>
									{address}
								</Typography>
								<Link className="propertyName" target={isMobile ? "_self" : "_blank"} to={`/property/${listingSlug}-${listingSeq}`} style={{ color: '#000000', textDecoration: 'underline' }} component={'span'} variant='body2'>
									{propertyName}
								</Link>
								<Typography component={'span'} variant='body2' sx={{ mb: 1, color: 'var(--grey900)' }} >
									{address2}
								</Typography>
							</Box>
							:
							<Typography component={'span'} variant='body2' sx={{ color: 'var(--grey900)' }}>
								{address}
							</Typography>
					}

					{
						packageType === 'experience' &&

						<Box sx={{
							"& .MuiChip-root": {
								width: 'fit-content',
								height: '28px !important'
							},
							display: 'flex',
							gap: 1,
							flexWrap: 'wrap',
							mt: 4
						}}>
							{durationObj &&
								// <Chip
								// 	icon={<Icon.AccessTimeOutlined />}
								// 	// label={`${extractDataFromArray(props, ['durationObj', 'value'], '')} ${extractDataFromArray(props, ['durationObj', 'unit'], '')}`}
								// 	label={`${generatePhrase(
								// 		parseInt(extractDataFromArray(durationObj, ['value'], 0)),
								// 		(extractDataFromArray(durationObj, ['unit'], 'hours') === 'hours' ? 'Hour' : 'Day')
								// 	)}`}
								// />
								<CreateChip
									chipType={'time'}
									caption={
										`${generatePhrase(
											parseInt(extractDataFromArray(durationObj, ['value'], 0)),
											(extractDataFromArray(durationObj, ['unit'], 'hours') === 'hours' ? 'Hour' : 'Day')
										)}`
									}
								/>
							}
							{
								// <Chip
								// 	icon={<img src={iconPath} style={{ height: '16px', width: '16px' }} />}
								// 	label={`${extractDataFromArray(generalData, ['experience_type'], '')}`}
								// />
								<CreateChip chipType={extractDataFromArray(generalData, ['experience_type'], '')} />
							}

						</Box>
					}

				</Box>
			</Box>
		</Box>
	)
}

const validationSchema = {
	reason: {
		type: 'string',
		required: true,
		requiredMsg: 'Reason is required',
	},
	more_info: {
		type: 'string',
		required: true,
		requiredMsg: 'Field is required',
		max: 5000,
		maxMsg: "Maximum 5000 characters allowed.",
	},
	other_reason: {
		type: 'string',
		required: true,
		requiredMsg: 'Reason is required',
		checkIf: {
			field: 'reason',
			is: 'Others',
		},
	},

}

const CancellationPopup = ({ open, handleClose, bookingData, type = 'cancel', getBookingDetails, setLoaderDeclineButton }) => {
	const [cancelReasons, setCancelReasons] = useState([])
	const [errors, setErrors] = useState({})
	const [selectedOptions, setSelectedOptions] = useState({
		reason: '',
		more_info: '',
		other_reason: '',
	})

	const [paymentDetails, setPaymentDetails] = useState({})

	const { isNineHundred } = CommonContext();

	const handleCancelSubmit = () => {
		let errorArray = validateJSON(selectedOptions, validationSchema)
		setErrors(errorArray)
		if (!empty(errorArray)) {
			return;
		}

		handleClose();

		if (type === 'cancel') {
			// console.log(bookingData.booking.id)
			BookingService.cancelBooking(bookingData.booking.id, selectedOptions.reason, selectedOptions.other_reason, selectedOptions.more_info, setLoaderDeclineButton, getBookingDetails, () => {
				getBookingDetails()
				// toast.success("Booking cancelled successfully", {
				// 	theme: 'colored'
				// })
				toastMessage(errorAndHelperText.cancel_booking.success)
				setLoaderDeclineButton(false)
				// navigate(`/booking/${bookingData.booking.id}`)
			})
		} else {
			BookingService.declineBooking(bookingData.booking.id, selectedOptions.reason, selectedOptions.other_reason, selectedOptions.more_info, setLoaderDeclineButton, () => {
				getBookingDetails()
				setLoaderDeclineButton(false)
				// toast.success("Booking declined successfully", {
				// 	theme: 'colored'
				// })
				toastMessage(errorAndHelperText.decline_booking.success);
				// navigate(`/booking/${bookingData.booking.id}`)
			})
		}

	}

	useEffect(() => {
		BookingService.getCancellationReasons((data) => {
			setCancelReasons(data)
		})
	}, [])

	useEffect(() => {
		if (open) {
			BookingService.getCancelationData(bookingData.booking.id, (data) => {
				setPaymentDetails(data)
				if (data.cancelationResaons) {
					setCancelReasons(data.cancelationResaons)
				}
			})
		} else {

		}
	}, [open])

	const action = type === 'cancel' ? 'Cancel' : 'Decline'
	const label = type === 'cancel' ? 'Reason for Cancellation' : 'Decline Reason'

	let packageCardMobileData = {
		image: '',
		thumbnail_url: '',
		title: '',
		area: '',
		address: '',
		propertyName: '',
		listingSlug: '',
		listing_seq: '',
		slug: '',
		seq: '',
		nearest_town: '',
		showBorder: false,
		activity_type: '',
		type: '',
	}

	if (bookingData.package_type === EXPERIENCE.value) {
		let data = extractDataFromArray(bookingData, ['package', 'experience_data'], {})
		for (let key in data) {
			if (data[key].type === 'photos') {
				packageCardMobileData.image = data[key].photo_list[0]
			}
			if (data[key].type === 'general_info') {
				packageCardMobileData.title = data[key].title
				packageCardMobileData.slug = data[key].slug
				packageCardMobileData.seq = data[key].seq
			}
			if (data[key].type === 'location') {
				packageCardMobileData.address = data[key].address
				if (packageCardMobileData.address === 'Don’t see your address? Add GPS coordinates.') {
					packageCardMobileData.address = 'Nearest Town, ' + data[key].city
				}
			}
		}
	} else if (bookingData.package_type === ACCESS.value) {
		packageCardMobileData.image = extractDataFromArray(bookingData, ['package', 'media_url'], '')
		packageCardMobileData.title = extractDataFromArray(bookingData, ['package', 'title'], '')
		packageCardMobileData.area = extractDataFromArray(bookingData, ['listing', 'area'], '')
		packageCardMobileData.address = extractDataFromArray(bookingData, ['listing', 'address'], '')
		packageCardMobileData.propertyName = extractDataFromArray(bookingData, ['listing', 'title'], '')
		packageCardMobileData.listingSlug = extractDataFromArray(bookingData, ['listing', 'slug'], '')
		packageCardMobileData.listing_seq = extractDataFromArray(bookingData, ['listing', 'seq'], '')
		packageCardMobileData.seq = extractDataFromArray(bookingData, ['package', 'seq'], '')
		packageCardMobileData.slug = extractDataFromArray(bookingData, ['package', 'slug'], '')
		packageCardMobileData.nearest_town = extractDataFromArray(bookingData, ['listing', 'nearest_town'], '')
		packageCardMobileData.activity_type = extractDataFromArray(bookingData, ['package', 'activity_type'], '')

	}

	return (
		<Dialog open={open && cancelReasons?.length > 0} onClose={(e, r) => { if (r && r === "backdropClick") return; handleClose() }} maxWidth="md">
			<Box >
				<Box sx={{ py: 1.5, px: 2.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography variant="h6" sx={{ fontWeight: 700 }}>{action} Booking</Typography>
					<IconButton onClick={() => { handleClose(); setLoaderDeclineButton(false); }}><Icon.Close /> </IconButton>
				</Box>
				<Divider />
				<Box sx={{ p: 2.5, maxWidth: "800px" }}>
					{!isNineHundred ?
						<PackageCard bookingData={bookingData} />
						:
						<PackageCardMobile
							image={packageCardMobileData.image}
							title={packageCardMobileData.title}
							area={packageCardMobileData.area}
							address={packageCardMobileData.address}
							propertyName={packageCardMobileData.propertyName}
							listingSlug={packageCardMobileData.listingSlug}
							listing_seq={packageCardMobileData.listing_seq}
							slug={packageCardMobileData.slug}
							seq={packageCardMobileData.seq}
							nearest_town={packageCardMobileData.nearest_town}
							showBorder={false}
							activity_type={packageCardMobileData.activity_type}
							listingType={bookingData.package_type}
						/>
					}
					<FormControl fullWidth sx={{ my: 2 }} size="small">
						<GreyLabel label={label} required></GreyLabel>
						<Select
							IconComponent={Icon.KeyboardArrowDownOutlined}
							value={selectedOptions.reason}
							onChange={(e) => {
								setSelectedOptions({ ...selectedOptions, reason: e.target.value })
							}}

						>
							{
								cancelReasons?.map((reason, index) => {
									return <MenuItem key={"reason_" + index} value={reason} style={{ whiteSpace: 'normal' }}>{reason}</MenuItem>
								})
							}
						</Select>
						{
							!empty(extractDataFromArray(errors, 'reason', '')) &&
							<FormHelperText sx={{ marginLeft: 0 }} error={true}>{extractDataFromArray(errors, 'reason', '')}</FormHelperText>
						}
					</FormControl>
					{
						selectedOptions.reason === "Others" &&
						<FormControl fullWidth sx={{ mb: 2 }}>
							<GreyLabel label="Other Reason" required></GreyLabel>
							<TextField
								fullWidth
								value={selectedOptions.other_reason}
								onChange={(e) => {
									setSelectedOptions({ ...selectedOptions, other_reason: e.target.value })
								}}
								error={errors.other_reason ? true : false}
								helperText={errors.other_reason ? errors.other_reason : ''}
							/>
						</FormControl>
					}
					<FormControl fullWidth sx={{ mb: 2 }}>
						<GreyLabel label="Any other details" required></GreyLabel>
						<TextField
							fullWidth
							multiline
							rows={4}
							value={selectedOptions.more_info}
							onChange={(e) => {
								setSelectedOptions({ ...selectedOptions, more_info: e.target.value })
							}}
							sx={{ mb: 2 }}
							placeholder="If there is something specific you want us to know regarding your cancellation, add that here"
							error={errors.more_info ? true : false}
							helperText={errors.more_info ? errors.more_info : ''}
						/>
					</FormControl>
					<Button variant="contained" color="error" fullWidth sx={{ mb: 3 }} onClick={handleCancelSubmit}>{action} Booking</Button>
					{type === 'cancel' && config.module === 'guest' &&
						<>
							<Typography variant="h6" sx={{ fontWeight: 700 }}>Cancellation Policy</Typography>
							{/* <Typography sx={{ mb: 2, color: 'var(--grey900)' }}>
								To be eligible for a full refund, guests must cancel within 48 hours
								of confirming their booking. Cancellations made after this period are
								non-refundable. Please note that cancellations are not permitted for
								bookings made less than 24 hours before the check-in time. In the
								event that a booking is declined or cancelled by the host at any
								point, a full refund will be issued.</Typography> */}
							<Typography sx={{ mb: 2, color: 'var(--grey900)' }}>{extractDataFromArray(paymentDetails, ['cancelationPolicy', 'policyDetails'], '')}</Typography>
							<Typography variant="h6" sx={{ fontWeight: 700 }}>Payment Details</Typography>
							<Typography sx={{ mb: 2, color: 'var(--grey900)' }} >The amount paid is inclusive of the FarWide fee.</Typography>
							<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
								<Typography>{extractDataFromArray(paymentDetails, ['refunds', 'booking_amount', 'caption'], '')}</Typography>
								<Typography>${extractDataFromArray(paymentDetails, ['refunds', 'booking_amount', 'value'], '')}</Typography>
							</Box>
							{/* <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
								<Typography>{extractDataFromArray(paymentDetails, ['refunds', 'deductions', 'deduction_amount',], '')}</Typography>
								<Typography>${extractDataFromArray(paymentDetails, ['refunds', 'deductions', 'deduction_amount', 'value'], '')}</Typography>
							</Box> */}
							{
								paymentDetails.refunds?.deductions?.map((deductions) => {
									return (
										<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
											<Typography>{extractDataFromArray(deductions, ['caption'], '')}</Typography>
											<Typography>${extractDataFromArray(deductions, ['value'], '')}</Typography>
										</Box>
									)
								})
							}
							<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
								<Typography>{extractDataFromArray(paymentDetails, ['refunds', 'refund_amount', 'caption'], '')}</Typography>
								<Typography>${extractDataFromArray(paymentDetails, ['refunds', 'refund_amount', 'value'], '')}</Typography>
							</Box>
						</>
					}
				</Box>
			</Box>
		</Dialog>
	)
}

export default CancellationPopup;